import { useEffect, useState } from "react";
import { Gift, Copy, CheckCircle2, Share2 } from "lucide-react";
import { api } from "@/lib/api";
import { FullSpinner } from "@/components/States";
import { toast } from "sonner";

export default function Referral() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/referrals").then(({ data }) => setData(data)); }, []);
  if (!data) return <FullSpinner />;
  const link = `${window.location.origin}/register?ref=${data.code}`;
  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copied to clipboard"); };
  const share = async () => {
    try { await navigator.share({ title: "Join me on ManaJodi", text: "Find your Jodi on ManaJodi.", url: link }); }
    catch { copy(link); }
  };
  return (
    <div className="max-w-2xl mx-auto space-y-5" data-testid="referral-page">
      <h1 className="font-serif text-3xl font-bold text-[#58111A] flex items-center gap-2"><Gift className="w-6 h-6 text-[#C59B27]" /> Invite Friends</h1>
      <div className="mj-card p-6 text-center">
        <p className="text-sm text-[#605255] mb-4">{data.reward_text}</p>
        <div className="text-xs uppercase tracking-wider text-[#9E7B1B] font-semibold">Your invite code</div>
        <div className="font-serif text-3xl font-bold text-[#781826] my-2 tracking-wide" data-testid="referral-code">{data.code}</div>
        <div className="flex gap-2 mt-4">
          <input readOnly value={link} className="mj-input text-xs" data-testid="referral-link" />
          <button onClick={() => copy(link)} className="btn-outline shrink-0"><Copy className="w-4 h-4" /></button>
          <button onClick={share} className="btn-primary shrink-0"><Share2 className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="mj-card p-4 text-center"><div className="font-serif text-2xl font-bold text-[#58111A]">{data.total}</div><div className="text-xs text-[#605255]">Friends Joined</div></div>
        <div className="mj-card p-4 text-center"><div className="font-serif text-2xl font-bold text-[#15803D]">{data.verified}</div><div className="text-xs text-[#605255]">Verified (Eligible)</div></div>
      </div>
      {data.referrals.length > 0 && (
        <div className="mj-card p-5">
          <h2 className="font-serif text-lg font-semibold text-[#261A1C] mb-2">Your Referrals</h2>
          {data.referrals.map((r) => (
            <div key={r.id} className="flex items-center justify-between py-2 border-b border-[#F1E9DA] last:border-0">
              <span className="text-sm text-[#261A1C]">{r.name}</span>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full flex items-center gap-1 ${r.status === "verified" ? "text-emerald-700 bg-emerald-50" : "text-amber-700 bg-amber-50"}`}>
                {r.status === "verified" && <CheckCircle2 className="w-3 h-3" />}{r.status}
              </span>
            </div>
          ))}
        </div>
      )}
      <p className="text-xs text-[#9E7B1B] text-center">Rewards apply to genuine, verified sign-ups only. Self-referrals and abuse are not eligible.</p>
    </div>
  );
}
